function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Close");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "cross-circle",
  fill: "#000000",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M17.0707071,2.92929293 C15.1809764,1.03956229 12.6725589,0 10,0 C7.32744108,0 4.81902357,1.03956229 2.92929293,2.92929293 C1.03956229,4.81902357 0,7.32744108 0,10 C0,12.6725589 1.03956229,15.1809764 2.92929293,17.0707071 C4.81902357,18.9604377 7.32744108,20 10,20 C12.6725589,20 15.1809764,18.9604377 17.0707071,17.0707071 C18.9604377,15.1809764 20,12.6725589 20,10 C20,7.32744108 18.9604377,4.81902357 17.0707071,2.92929293 Z M16.266835,16.266835 C14.5917508,17.9419192 12.3653199,18.8636364 10,18.8636364 C7.63468013,18.8636364 5.40824916,17.9419192 3.73316498,16.266835 C0.277777778,12.8114478 0.277777778,7.18855219 3.73316498,3.73316498 C5.40824916,2.05808081 7.63468013,1.13636364 10,1.13636364 C12.3653199,1.13636364 14.5917508,2.05808081 16.266835,3.73316498 C19.7222222,7.18855219 19.7222222,12.8114478 16.266835,16.266835 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M14.4465679,5.55341266 C14.221479,5.32834963 13.8604873,5.32834963 13.6353984,5.55341266 L10,9.18839298 L6.36460158,5.55341266 C6.13951266,5.32834963 5.778521,5.32834963 5.55343208,5.55341266 C5.32834315,5.77847569 5.32834315,6.13942584 5.55343208,6.36448888 L9.18883049,9.99946919 L5.55343208,13.6344495 C5.32834315,13.8595125 5.32834315,14.2204627 5.55343208,14.4455257 C5.66385306,14.555934 5.81249668,14.6153846 5.95689335,14.6153846 C6.10129001,14.6153846 6.24993364,14.5601805 6.36035462,14.4455257 L9.99575304,10.8105454 L13.6311515,14.4455257 C13.7415724,14.555934 13.8902161,14.6153846 14.0346127,14.6153846 C14.1832564,14.6153846 14.327653,14.5601805 14.438074,14.4455257 C14.6631629,14.2204627 14.6631629,13.8595125 14.438074,13.6344495 L10.8111695,9.99946919 L14.4465679,6.36448888 C14.6716568,6.13942584 14.6716568,5.77847569 14.4465679,5.55341266 Z",
  id: "Path"
})));

var SvgCrossCircle = function SvgCrossCircle(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCrossCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cross-circle.9384527b.svg";
export { ForwardRef as ReactComponent };